import {useEffect} from 'react'
import {useSharedStore} from '../state/shared-store-context'
import {publicConfig} from '../shared/public-config'
import {clientLogger} from '../shared/client-logger'

export const usePublicConfig = () => {
    const {actions} = useSharedStore()

    useEffect(() => {
        let active = true
        publicConfig.getConfig()
            .then(config => {
                if (!active) return
                actions.setPublicConfig(config)
                actions.setPublicConfigError(null)
                clientLogger.enable()
            })
            .catch(error => {
                if (!active) return
                actions.setPublicConfigError(error?.message || 'Failed to load config')
            })

        return () => { active = false }
    }, [actions])
}
